import React, { Component, useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Card, Col, Row, Form, Button, CardBody, CardHeader, Modal, ModalHeader, ModalBody, CustomInput, Input, Badge } from 'reactstrap';
import { getAPI } from "../../Base/API";
import { ErrorAlert } from "../../Common/ErrorAlert";
import BlockUi from 'react-block-ui';
import moment from 'moment';
import { CustomDateRangePicker } from '../../Base/Common/CustomReactDates';
import { handleNotification } from '../../Base/Notification';
import { CustomTable } from '../../Base/Common/CustomTable';
import { FormatAmountNumber } from '../../Base/Common/CommonUIComponents';
import { ResultsPerPage, TotalResults, Pagination } from '../../Base/Common/PaginationComponents';


class Shift4Customers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: [],
            block: false,
            totalCount: 0,
            customers: [],
            totalCount: 0,
            limit: 10,
            startingAfter: null,
            endingBefore: null,
            page: 0,
        }
    }

    componentDidMount() {
        this.getCustomers()
    }

    getCustomers = (endingBefore, startingAfter) => {
        this.setState({ block: true });

        var params = `?startDate=${moment(this.props.startDate).format("YYYY-MM-DD")}&endDate=${moment(this.props.endDate).format("YYYY-MM-DD")}&limit=${this.state.limit}`;

        if (endingBefore) params += `&endingBefore=${endingBefore}`;
        else if (startingAfter) params += `&startingAfter=${startingAfter}`;

        if (this.state.email) params += `&email=${this.state.email}`;
        if (this.state.customerId) params += `&customerId=${this.state.customerId}`;


        getAPI(result => {
            const { data, error } = result;
            var errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors?.length > 0) {
                    handleNotification(data);
                    this.setState(({ block: false, error: errorMessage }));
                    return;
                }

                var customers = data.response[0]?.list;
                var totalCount = data.response[0]?.totalCount;
                var hasMore = data.response[0]?.hasMore;
                var endingBefore = null;
                var startingAfter = null;

                if (customers?.length > 0) {
                    var page = this.state.page; 
                    
                    if (page === 0 && totalCount > this.state.limit) startingAfter = customers[customers.length - 1]?.id;
                    if (page !== 0) {
                        if (hasMore) {
                            startingAfter = customers[customers.length - 1]?.id;
                        }
                            
                        endingBefore = customers[0]?.id;
                    }
                }
                

                this.setState({ 
                    customers, totalCount,
                    hasMore, startingAfter, endingBefore, 
                    block: false, 
                    error: errorMessage 
                });
            }
            else {
                this.setState(({ block: false, error: errorMessage }));
            }
        }, `/api/Price/Shift4/v1/customers` + params);
    }

    doSearch = (evt) => {
        evt.preventDefault();

        this.setState({ page: 0 }, () => this.getCustomers());
    }

    handlePagination = (direction) => {
        const { endingBefore, startingAfter, page } = this.state;

        if (direction === -1 && endingBefore) {
            this.setState(
                { page: page - 1 },
                () => this.getCustomers(endingBefore, null)
            );
        } else if (direction === 1 && startingAfter) {
            this.setState(
                { page: page + 1 },
                () => this.getCustomers(null, startingAfter)
            );
        }
    }
        
    changePageSize = (evt) => {
        const { value } = evt.target;

        if (this.state.limit !== value) {
            this.setState({ limit: value, page: 0 }, _ => this.getCustomers());
        }
    }

    toggleModal = (modal, selectedCustomerId) => {
        this.setState(prevState => ({
            [modal]: !prevState[modal],
            selectedCustomerId: selectedCustomerId
        }));
    }

    render() {
        const { block, customers, selectedCustomerId, modal, totalCount, limit, endingBefore, startingAfter, page } = this.state;

        const columns = [
            {
                dataField: 'email',
                text: this.props.intl.formatMessage({ id: "generic.Email" })
            },
            {
                dataField: 'id',
                text: "Customer"
            },
            {
                dataField: 'created',
                text: this.props.intl.formatMessage({ id: "generic.CreatedDate" }),
                formatter: (cell) => moment.unix(cell).format("MM/DD/YYYY")
            }
        ]

            
        const selectRow = {
            mode: 'radio',
            hideSelectColumn: true,
            bgColor: '#f8f9fa',
            clickToSelect: true,

            onSelect: (row, isSelect, rowIndex, e) => {
                this.toggleModal('modal', row.id);
            }
        };

        return (
            <BlockUi tag="div" blocking={block}>
                <ErrorAlert error={this.state.error} />
                
                <Card className="border-0 shadow ">
                    <CardHeader className="bg-white border-bottom py-2">
                        <div><span className="fas fa-users mr-2"> </span> <FormattedMessage id="PaymentManagement.Customers" /> </div>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={this.doSearch} className="mb-4">
                            <Row className="align-items-end">
                                <Col>
                                    <Input
                                        type="text"
                                        name="email" 
                                        maxLength="200"
                                        placeholder={this.props.intl.formatMessage({ id: "generic.Email" })}
                                        value={this.state.email}
                                        onChange={(e) => this.setState({ email: e.target.value })}
                                    />
                                </Col>
                                <Col>
                                    <Input
                                        type="text"
                                        name="customerId" 
                                        maxLength="200"
                                        placeholder={this.props.intl.formatMessage({ id: "PaymentManagement.Customer" })}
                                        value={this.state.customerId}
                                        onChange={(e) => this.setState({ customerId: e.target.value })}
                                    />
                                </Col>
                                <Col>
                                    <CustomDateRangePicker
                                        required
                                        startDate={this.props.startDate}
                                        startDateId="your_unique_start_date_id_customers"
                                        isOutsideRange={day => day > moment()}
                                        endDate={this.props.endDate}
                                        endDateId="your_unique_end_date_id_customers"
                                        onDatesChange={(startDate, endDate) => this.props.handleDates({ startDate, endDate })}
                                        numberOfMonths={1}
                                    />
                                </Col>
                                <Col className="d-flex justify-content-end align-items-center">
                                    <Button className="btn btn-host btn-sm " type="submit">
                                        <i className="fa fa-search" />
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                        <Row>
                            <Col>                            
                                <CustomTable
                                    data={customers || []}
                                    columns={columns}
                                    search={false}
                                    small={true}
                                    exportCSV={false}
                                    selectRow={selectRow}
                                    hideSizePerPage={true}
                                    sizePerPage={limit}
                                    hasPagination={false}
                                />
                            </Col>
                        </Row>
                        {totalCount > 0 ?
                            <div className="py-4 d-flex align-items-center">
                                <div className='w-50' style={{maxWidth: '50%'}}>
                                    <ResultsPerPage
                                        changeSizePerPage={this.changePageSize}
                                        pageSize={limit}
                                    />

                                    {!global.isMobile ?
                                        <span className="ml-2">
                                            <TotalResults
                                                end={page * limit + customers.length}
                                                start={page * limit + 1}
                                                total={totalCount}
                                            />
                                        </span>
                                    :''}
                                </div>
                                <div className="w-50 d-flex justify-content-end" style={{maxWidth: '50%'}}>
                                    <Pagination
                                        isPrevDisabled={!endingBefore}
                                        isNextDisabled={!startingAfter}
                                        currentPage={page + 1}
                                        handlePrevButton={() => this.handlePagination(-1)}
                                        handleNextButton={() => this.handlePagination(1)}
                                    />
                                </div>
                            </div>
                        : ''}
                    </CardBody>
                </Card>

                {(modal && selectedCustomerId) ?
                    <CustomerDetails
                        modal={modal}
                        toggleModal={() => this.toggleModal('modal')}
                        customerId={selectedCustomerId}
                        intl={this.props.intl}
                        startDateProps={this.props.startDate}
                        endDateProps={this.props.endDate}
                        chargeStatus={this.props.chargeStatus}
                    />
                : ''}
            </BlockUi>
        )
    }
}

export default injectIntl(Shift4Customers);


const CustomerDetails = ({ modal, toggleModal, customerId,  intl, startDateProps, endDateProps, chargeStatus }) => {
    const [startDate, setStartDate] = useState(startDateProps);
    const [endDate, setEndDate] = useState(endDateProps);
    const [block, setBlock] = useState(false);
    const [customer, setCustomer] = useState(null);
    const [charges, setCharges] = useState([]);
    const [limit, setLimit] = useState(5);
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(0);
    const [startingAfter, setStartingAfter] = useState(null);
    const [endingBefore, setEndingBefore] = useState(null);

    useEffect(() => {
        getCustomerDetails();
        
    }, [customerId]);
    
    useEffect(() => {
        getCustomerCharges(endingBefore, startingAfter);
    }, [page, limit]);

    const getCustomerDetails = () => {
        setBlock(true);

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                setBlock(false);
                return;
            }
            if (data) {
                if (data.errors?.length > 0) {
                    handleNotification(data);
                    setBlock(false);
                    return;
                }

                setCustomer(data.response[0]?.list?.[0]);
                setBlock(false);
            }
            else {
                setBlock(false);
            }
        }, `/api/Price/Shift4/v1/customers/${customerId}`);
    }

    const getCustomerCharges = (endingBefore, startingAfter) => {
        setBlock(true);

        var params = `?customerId=${customerId}&startDate=${moment(startDate).format("YYYY-MM-DD")}&endDate=${moment(endDate).format("YYYY-MM-DD")}&limit=${limit}`;

        if (endingBefore) params += `&endingBefore=${endingBefore}`;
        else if (startingAfter) params += `&startingAfter=${startingAfter}`;

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                setBlock(false);
                return;
            }
            if (data) {
                if (data.errors?.length > 0) {
                    handleNotification(data);
                    setBlock(false);
                    return;
                }

                var charges = data.response[0]?.list;
                var totalCount = data.response[0]?.totalCount;
                var hasMore = data.response[0]?.hasMore;
                var endingBefore = null;
                var startingAfter = null;

                if (charges?.length > 0) {
                    if (page === 0 && totalCount > limit) startingAfter = charges[charges.length - 1]?.id;
                    if (page !== 0) {
                        if (hasMore) {
                            startingAfter = charges[charges.length - 1]?.id;
                        }
                            
                        endingBefore = charges[0]?.id;
                    }
                }

                setCharges(charges);
                setTotalCount(totalCount);
                setStartingAfter(startingAfter);
                setEndingBefore(endingBefore);
                setBlock(false);
            }
            else {
                setBlock(false);
            }
        }, `/api/Price/Shift4/v1/charges` + params);
    }

    const doSearch = (evt) => {
        evt.preventDefault();

        setPage(0);
        getCustomerCharges();
    }

    const handlePagination = (direction) => {
        if (direction === -1 && endingBefore) {
            setPage(page - 1);
        } 
        else if (direction === 1 && startingAfter) {
            setPage(page + 1);
        }
    }
        
    const changePageSize = (evt) => {
        const { value } = evt.target;

        if (limit !== value) {
            setStartingAfter(null);
            setEndingBefore(null);
            setLimit(value);
            setPage(0);
        }
    }

    const columns = [
        {
            dataField: 'id',
            text: "Id"
        },
        {
            dataField: 'created',
            text: intl.formatMessage({ id: "generic.Date" }),
            formatter: (cell) => moment.unix(cell).format("MM/DD/YYYY")
        },
        {
            dataField: 'type',
            text: intl.formatMessage({ id: "generic.Type" })
        },
        {
            dataField: 'amount',
            text: intl.formatMessage({ id: "generic.Amount" }),
            formatter: (cell, row) => <FormatAmountNumber value={(cell / 100).toFixed(2)} currency={row.currency} />
        },
        {
            dataField: 'amountRefunded',
            text: intl.formatMessage({ id: "PaymentManagement.Refund" }),
            formatter: (cell, row) => <FormatAmountNumber value={(cell / 100).toFixed(2)} currency={row.currency} />
        }, 
        {
            dataField: 'description',
            text: intl.formatMessage({ id: "generic.Description" })
        },
        {
            dataField: 'customerId',
            text: intl.formatMessage({ id: "PaymentManagement.Customer" })
        },
        {
            dataField: 'captured',
            text: intl.formatMessage({ id: "PaymentManagement.Captured" }),
            formatter: (cell, row) => 
                <CustomInput
                    type="checkbox"
                    className="mb-1"
                    checked={cell}
                    disabled
                    id={`capture_${row.id}`}
                />
        },
        {
            dataField: 'refunded',
            text: intl.formatMessage({ id: "PaymentManagement.Refunded" }),
            formatter: (cell, row) => 
                <CustomInput
                    type="checkbox"
                    className="mb-1"
                    checked={cell}
                    disabled
                    id={`capture_${row.id}`}
                />
        },
        {
            dataField: 'disputed',
            text: intl.formatMessage({ id: "PaymentManagement.Disputed" }),
            formatter: (cell, row) => 
                <CustomInput
                    type="checkbox"
                    className="mb-1"
                    checked={cell}
                    disabled
                    id={`capture_${row.id}`}
                />
        },
        {
            dataField: 'status',
            text: intl.formatMessage({ id: "generic.Status" }),
            formatter: (cell) => {
                const status = chargeStatus.find(status => status.value === cell);

                if (status) {
                    return <Badge color={status.color}>{status.label}</Badge>
                }
            }
        }
    ]

    return (
        <Modal isOpen={modal} toggle={toggleModal} fade={false} className="modal-xl" >
            <ModalHeader toggle={toggleModal}  >
                <FormattedMessage id="PaymentManagement.CustomerDetails" />
            </ModalHeader>
            <ModalBody>
                <BlockUi tag="div" blocking={block}>
                    <Card className="border-0">
                        <CardHeader className="mb-1 bg-light-dark py-2">
                            <b><FormattedMessage id="PaymentManagement.Customer" /></b>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col sm={2} className="mb-2"> Id </Col>
                                <Col sm={4} className="mb-2"> <b>{customer?.id} </b> </Col>
                                <Col sm={2} className="mb-2"> <FormattedMessage id="generic.CreatedDate" /> </Col>
                                <Col sm={4} className="mb-2"> <b>{moment.unix(customer?.created).format("MM/DD/YYYY")} </b></Col>
                                <Col sm={2} className="mb-2"> <FormattedMessage id="generic.name" /> </Col>
                                <Col sm={4} className="mb-2"> <b>{customer?.name} </b> </Col>
                                <Col sm={2} className="mb-2"> <FormattedMessage id="generic.Email" /> </Col>
                                <Col sm={4} className="mb-2"> <b>{customer?.email} </b> </Col>
                                <Col sm={2} className="mb-2"> <FormattedMessage id="generic.Phone" /> </Col>
                                <Col sm={4} className="mb-2"> <b>{customer?.phone} </b> </Col>
                                <Col sm={2} className="mb-2"> <FormattedMessage id="generic.Address" /> </Col>
                                <Col sm={4} className="mb-2"> <b>{customer?.address?.line1} </b> </Col>
                                <Col sm={2} className="mb-2"> <FormattedMessage id="generic.VatNumber" /> </Col>
                                <Col sm={4} className="mb-2"> <b>{customer?.taxInfo?.vatNumber} </b> </Col>
                                <Col sm={2} className="mb-2"> <FormattedMessage id="generic.Description" /> </Col>
                                <Col sm={4} className="mb-2"> <b>{customer?.description} </b> </Col>
                                <Col sm={2} className="mb-2"> <FormattedMessage id="generic.Mode" /> </Col>
                                <Col sm={4} className="mb-2"> <b>{customer?.mode} </b> </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card className="border-0 mt-3">
                        <CardHeader className="mb-1 bg-light-dark py-2">
                            <b><FormattedMessage id="PaymentManagement.Metadata" /></b>
                        </CardHeader>
                        <CardBody>
                            {customer?.metadata && Object.keys(customer?.metadata).length > 0 ?
                                <Row>
                                    <Col sm={4}>
                                        {Object.keys(customer?.metadata).map((key, index) => (
                                            <Row key={index} className="mb-2">
                                                <Col>{key}</Col> 
                                                <Col>{customer?.metadata[key]}</Col>
                                            </Row>
                                        ))}
                                    </Col>
                                </Row>
                                :
                                <div className='text-center'><FormattedMessage id="generic.table.nodata" /></div>
                            }
                        </CardBody>
                    </Card>

                    <Card className="border-0 mt-3">
                        <CardHeader className="mb-1 bg-light-dark py-2">
                            <b><FormattedMessage id="PaymentManagement.Cards" /></b>
                        </CardHeader>
                        <CardBody>
                            {customer?.cards?.length > 0 ?
                                <Row>
                                    {customer?.cards?.map((card, index) => (
                                        <Col key={index} className="mb-2 col-4">
                                            <Card body className="border shadow">
                                                <Row>
                                                    <Col>
                                                        <div className='text-muted font_size_xxs'>
                                                            {card.type}
                                                        </div>
                                                        {card.brand}
                                                    </Col>
                                                    <Col className="text-right">
                                                        <div className='text-muted font_size_xxs'>
                                                            <FormattedMessage id="generic.CreatedDate" />
                                                        </div>
                                                        {moment.unix(card.created).format("MM/DD/YYYY")}
                                                    </Col>
                                                </Row>
                                                <div className='mt-3 mb-1'>
                                                    <b>{card.cardholderName}</b>
                                                </div>
                                                <Row>
                                                    <Col>
                                                        {card.first6 ? card.first6.slice(0, 4) + card.first6.slice(4, 6) + '** **** ' + card.last4 : ''}
                                                    </Col>
                                                    <Col className="text-right">
                                                        {card.expMonth}/{card.expYear}
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                                :
                                <div className='text-center'><FormattedMessage id="generic.table.nodata" /></div>
                            }
                        </CardBody>
                    </Card>

                    <Card className="border-0 mt-3">
                        <CardHeader className="mb-1 bg-light-dark py-1">
                            <Row className="align-items-center">
                                <Col sm={6}>
                                    <b><FormattedMessage id="PaymentManagement.Charges" /></b>
                                </Col>
                                <Col>
                                    <Form onSubmit={(e) => doSearch(e)} >
                                        <div className="d-flex align-items-center justify-content-end">
                                            <CustomDateRangePicker
                                                required
                                                startDate={startDate}
                                                startDateId="your_unique_start_date_id_customers"
                                                isOutsideRange={day => day > moment()}
                                                endDate={endDate}
                                                endDateId="your_unique_end_date_id_customers"
                                                onDatesChange={(startDate, endDate) => { setStartDate(startDate); setEndDate(endDate); }}
                                                numberOfMonths={1}
                                            />
                                            
                                            <Button className="btn btn-host btn-sm ml-2" type="submit">
                                                <i className="fa fa-search" />
                                            </Button>
                                        </div>
                                    </Form>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            {charges?.length > 0 ?
                                <>
                                    <CustomTable
                                        data={charges || []}
                                        columns={columns}
                                        search={false}
                                        small={true}
                                        exportCSV={false}
                                        hideSizePerPage={true}
                                        sizePerPage={limit}
                                        hasPagination={false}
                                    />
                                    {totalCount > 0 ?
                                        <div className="py-4 d-flex align-items-center">
                                            <div className='w-50' style={{maxWidth: '50%'}}>
                                                <ResultsPerPage
                                                    changeSizePerPage={changePageSize}
                                                    pageSize={limit}
                                                />
            
                                                {!global.isMobile ?
                                                    <span className="ml-2">
                                                        <TotalResults
                                                            end={page * limit + charges.length}
                                                            start={page * limit + 1}
                                                            total={totalCount}
                                                        />
                                                    </span>
                                                :''}
                                            </div>
                                            <div className="w-50 d-flex justify-content-end" style={{maxWidth: '50%'}}>
                                                <Pagination
                                                    isPrevDisabled={!endingBefore}
                                                    isNextDisabled={!startingAfter}
                                                    currentPage={page + 1}
                                                    handlePrevButton={() => handlePagination(-1)}
                                                    handleNextButton={() => handlePagination(1)}
                                                />
                                            </div>
                                        </div>
                                    : ''}
                                </>
                                :
                                <div className='text-center'><FormattedMessage id="generic.table.nodata" /></div>
                            }
                        </CardBody>
                    </Card>
                </BlockUi>
            </ModalBody>
        </Modal>
    )
};